export function handleSearch(searchInput: string, value: string): boolean {
  const input: string = searchInput
    .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    .trim();
  const result: boolean = new RegExp(input, "i").test(value);

  return result;
}
